var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineRegistryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 24.6944C8.09369 24.6944 3.30569 19.9066 3.30569 14.0004C3.30569 8.09415 8.09369 3.30615 13.9999 3.30615C19.9064 3.30615 24.6942 8.09415 24.6942 14.0004C24.6942 14.4324 25.0448 14.7829 25.4767 14.7829C25.9085 14.7829 26.2589 14.4322 26.2589 14.0004C26.2589 7.23009 20.7703 1.74121 13.9999 1.74121C7.22962 1.74121 1.74097 7.23009 1.74097 14.0004C1.74097 20.7707 7.22962 26.2596 13.9999 26.2596C14.432 26.2596 14.7824 25.9089 14.7824 25.4771C14.7824 25.0453 14.432 24.6944 13.9999 24.6944Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5707 15C17.494 15 15 17.494 15 20.5707C15 23.6476 17.4938 26.1416 20.5707 26.1416C23.6472 26.1416 26.1412 23.6478 26.1412 20.5707C26.1412 17.494 23.6474 15 20.5707 15ZM20.6381 23.0517C20.3962 23.372 19.94 23.4354 19.6201 23.1935L17.3983 21.5138C17.0788 21.2723 17.0152 20.8163 17.2575 20.496C17.4992 20.176 17.9555 20.1127 18.275 20.3542L19.9172 21.5957L22.2325 18.5327C22.4744 18.2126 22.9304 18.1493 23.2503 18.3912C23.5702 18.6331 23.6338 19.0891 23.3917 19.4092L20.6381 23.0517Z",
    fill: "#24B282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2175 5.65378V14.2609H8.78301C8.35141 14.2609 8.00098 14.6116 8.00098 15.0434C8.00098 15.4759 8.35163 15.8263 8.78301 15.8263H14C14.432 15.8263 14.7824 15.4757 14.7824 15.0434V5.65378C14.7824 5.22153 14.4318 4.87109 14 4.87109C13.5682 4.87109 13.2175 5.22175 13.2175 5.65378Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineRegistryIcon);
export default __webpack_public_path__ + "static/media/timelineRegistryIcon.49415580ac78a5fb1eec402a3094ae1d.svg";
export { ForwardRef as ReactComponent };